export default __webpack_public_path__ + "static/media/welcomeBg.48cfe7a9.png";